import React from "react";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const DMCA = (props) => {
    const currentYear = new Date().getFullYear();

    const onCloseModal = () => {
	    props.setShowDMCA(false);
	}
    return (
        <Modal isOpen={true} className="rounded_modal" toggle={onCloseModal} backdrop="static" keyboard={true} size="lg">
            <button type="button" onClick={onCloseModal} className="close modalClose" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <ModalHeader>DMCA Notice and Trademark Infringement</ModalHeader>
            <ModalBody>
                <div className="clearfix mainSection">
	                <div className="container">
	                    <div className="clearfix contentWrapper">
	                        <div className="mainContent" id="mainContentHolder">
	                            <div className="row">
	                                <div className="col-md-12 col-lg-12">
	                                    <p>
	                                        <b>Last Updated January 2020</b><br/>
	                                    </p>
	                                    <p>Upward.careers
	                                        respects the intellectual property rights of others. If you believe something on this website has infringed your intellectual property rights, our policy is to respond to alleged infringement notices that comply with the Digital Millennium Copyright
	                                        Act of 1998 (the &quot;DMCA&quot;); please provide the following information in writing:</p>
	            
	                                    <ol>
	                                        <li>Identification of the work claimed to have been infringed;</li>
	                                        <li>Identification of the material that is claimed to be infringing and where it is located on the website;</li>
	                                        <li>Information reasonably sufficient to allow us to contact you, such as your address, telephone number, and e-mail address;</li>
	                                    </ol>
	            
	                                    <p>A statement that you have a good faith belief that use of the material in the manner complained of it not authorized by the intellectual property owner, its agent, or the law;</p>
	                                    <p>A statement, made under penalty of perjury, that the above information is accurate, and that you are the intellectual property owner or are authorized to act on behalf of the owner.</p>
	                                    <p>Our Agent can be reached using the Contact Us link on the website.</p>
	                                    <p>UNDER FEDERAL LAW, IF YOU KNOWINGLY MISREPRESENT THAT ONLINE MATERIAL IS INFRINGING, YOU MAY BE SUBJECT TO CRIMINAL PROSECUTION FOR PERJURY AND CIVIL PENALTIES, INCLUDING MONETARY DAMAGES, COURT COSTS, AND ATTORYNEYS&#39; FEES.</p>
	                                    <p>In accordance with the DMCA and other applicable law, we have a policy of terminating, if appropriate, Users, third party posters and employers who are deemed to be repeat infringers.</p>
	            
	                                    <div style={{"textAlign":"center","padding":"25px 0"}}>
	                                        Copyright © {currentYear} www.upward.net All rights reserved.
	                                    </div>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
            </ModalBody>
        </Modal>
    )

}

export default DMCA;
